export default "__VITE_ASSET__a0e91418__"